import { Injectable } from "@angular/core";
import { environment } from '../../../environments/environment';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import "rxjs/add/operator/map";

@Injectable({
  providedIn: "root",
})

export class AuthenticationService {
  server: string = environment.apiUrl;

  constructor(public http: HttpClient) { } 

  postData(body, file) {
    let headers = new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
    });
    let options = {
      headers: headers, 
    };

    return this.http
      .post(this.server + file, JSON.stringify(body), options)
      .map((res) => res);
  }
}